import { render, staticRenderFns } from "./registration-invitation-form.vue?vue&type=template&id=936bf0fc&scoped=true"
import script from "./registration-invitation-form.vue?vue&type=script&lang=js"
export * from "./registration-invitation-form.vue?vue&type=script&lang=js"
import style0 from "./registration-invitation-form.vue?vue&type=style&index=0&id=936bf0fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936bf0fc",
  null
  
)

export default component.exports